import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Configuration } from 'src/app/domain/configuration';
import { ELimitValueType } from 'src/app/domain/enum/limit-value-type';
import { Limit } from 'src/app/domain/limit';
import { UserService } from 'src/app/services/user.service';
import { StringConverter } from '../string-converter';
import { LimitCategory } from 'src/app/domain/limit-category';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-limit-box',
    templateUrl: './limit-box.component.html',
    styleUrl: './limit-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatSelectModule, MatOptionModule, MatButtonModule, PreventDoubleClickDirective]
})
export class LimitBoxComponent implements OnInit, AfterContentInit {
    public LimitValueTypeList: string[] = Object.values(ELimitValueType)
        .filter(x => !isNaN(Number(x)))
        .map(x => StringConverter.getLimitValueTypeName(x as ELimitValueType));
    CategoryList: LimitCategory[] = [];
    Model: Limit = new Limit();
    IsCreation: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<LimitBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.Model = Object.assign({}, data.limit);
        }
        if (data.limit)
            this.IsCreation = false;
        this.CategoryList = data.categoryList;
    }
    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }

    CanSave() {
        return this.Model.Name && (this.Model.Type1 && this.Model.Value1) || (this.Model.Type2 && this.Model.Value2);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }
}
